import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initWebVitals } from './utils/webVitals';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import { lazyWithReload } from './utils/lazyWithReload';
import { assertEnvIsolation } from './utils/envGuard';

// STAGING-1: build staging não pode apontar para API de produção
assertEnvIsolation();

const queryClient = new QueryClient();

// OPS_MODE: standalone ops app (ops.vukz.ai) — Entra ID auth, no client pages
const isOpsMode = process.env.REACT_APP_OPS_MODE === 'true';

const root = ReactDOM.createRoot(document.getElementById('root'));

if (isOpsMode) {
  // Lazy load OpsApp to avoid bundling governance in client build
  const OpsApp = lazyWithReload(() => import('./OpsApp'));
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <React.Suspense fallback={
            <div className="min-h-screen flex items-center justify-center bg-slate-50">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#111] mx-auto" />
            </div>
          }>
            <OpsApp />
          </React.Suspense>
        </QueryClientProvider>
      </HelmetProvider>
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </HelmetProvider>
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
initWebVitals();

// ── Legacy Service Worker cleanup (05/07/2026) ─────────────────────────────
// Um sw.js antigo (Workbox) ficou registrado nos browsers e interceptava
// chamadas à API ("no-response" flood no console). Cinto e suspensório com
// o kill-switch em public/sw.js: desregistra qualquer SW e limpa caches.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((regs) => Promise.all(regs.map((r) => r.unregister())))
    .catch(() => {});
  if (window.caches?.keys) {
    caches.keys()
      .then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
      .catch(() => {});
  }
}
